import { useRef, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { portalApi } from '../../../api/portal.js';
import { ApiError } from '../../../api/client.js';
import { PhotoGrid } from '../../../components/portal/PhotoGrid.jsx';

/**
 * The pet's photo album, with owner-contributed uploads. New photos are stored
 * private server-side and re-resolved with presigned URLs on reload.
 */
export function Gallery() {
  const { selectedPet, reloadPets } = useOutletContext();
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  if (!selectedPet) return null;

  const onPick = () => fileRef.current && fileRef.current.click();

  const onFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) return;
    setUploading(true);
    setError(null);
    try {
      const fd = new FormData();
      fd.append('file', file);
      await portalApi.uploadPhoto(selectedPet._id, fd);
      await reloadPets();
    } catch (err) {
      if (err instanceof ApiError && err.statusCode === 503) {
        setError('Il caricamento delle foto non è disponibile in questo momento.');
      } else {
        setError('Non siamo riusciti a caricare la foto. Riprova.');
      }
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="pt-2">
      <div className="mb-5 flex items-center justify-between">
        <h2 className="text-2xl font-semibold text-portal-ink">Galleria di {selectedPet.name}</h2>
        <button
          type="button"
          onClick={onPick}
          disabled={uploading}
          className="rounded-full bg-portal-brand px-4 py-2 text-sm font-medium text-white hover:bg-portal-brand-hover disabled:opacity-60"
        >
          {uploading ? 'Carico…' : 'Aggiungi foto'}
        </button>
        <input ref={fileRef} type="file" accept="image/*" hidden onChange={onFile} />
      </div>

      {error && <p className="mb-4 text-sm text-portal-brand">{error}</p>}

      <PhotoGrid
        photos={selectedPet.photos || []}
        emptyHint={`Aggiungi la prima foto di ${selectedPet.name}.`}
      />
    </div>
  );
}
